import { combineReducers } from 'redux';
import auth from './agent';
import agency from './agency';
import mailingProfile from './mailing-profile';
import mailingList from './mailing-list';
import mailingOrder from './mailing-order';
import enrollment from './enrollment';
import projects from './projects';

export default combineReducers({
  auth,
  agency,
  mailingProfile,
  mailingList,
  mailingOrder,
  projects,
  enrollment
});



// WEBPACK FOOTER //
// ./src/modules/index.js